import { put, call, cancelled, fork, take, select } from 'redux-saga/effects';
import { eventChannel } from 'redux-saga'
import { refreshData, updateClient } from "../actions/Firebase";
import { updateSession } from "../actions/Session"


function createChannel(firebaseApp) {
  var un = () => { }
  return eventChannel(emit => {
    setImmediate(() => {
      un = firebaseApp.auth().onAuthStateChanged((user) => {
        console.log("USER C U", user);
        if (user) {
          emit({user})
        } else {
          emit({user: null})
        }
      })
    });
    const unsubs = () => {
      un();
    }
    return unsubs;
  });
}

function* subscribeToEvent(firebaseApp, callback) {
  let channel;
  try {
    channel = yield call(createChannel, firebaseApp);
  } catch (chanErr) {
    console.tron.error(`Error creating subscription channel for event`, chanErr);
    throw chanErr;
  }

  while (true) {
    try {
      const data = yield take(channel);
      yield fork(callback, data);
    } catch (err) {
      if (yield cancelled()) {
        channel.close();
        return;
      } else {
        console.tron.error(`Error in saga task for event`, err);
      }
    }
  }
}

export function* initialize({ firebaseApp }) {
  const db = firebaseApp.firestore()
  yield fork(subscribeToEvent, firebaseApp, function* (currentUser) {
    yield put(updateSession(currentUser.user));
  })
  yield put(updateClient(
    {
      app: firebaseApp,
      stationsCollection: db.collection('stations'),
      loadsCollection: db.collection('loads'),
      tokensCollection: db.collection('credentials'),
    }))

}

//Agrega una estacion
export function* addDocument(action) {
  const { firebase } = yield select(state => state)
  var new_slots = []
  var date_values = action.payload.data.date.split("-")
  var new_date = new Date(parseInt(date_values[0]), parseInt(date_values[1]), parseInt(date_values[2]))
  var new_timestamp = new_date.getTime()
  new_date = date_values[2] + "/" + date_values[1] + "/" + date_values[0]
  for (var i = 0; i < action.payload.data.number_slots; i++) {
    new_slots.push({
      available: true,
      vehicle: "",
      charging: false
    })
  }
  new_slots = Object.assign({}, new_slots)
  var new_station = {
    available: true,
    position: action.payload.data.position,
    timestamp: new_timestamp,
    slots: new_slots,
    date: new_date
  }
  firebase.stationsCollection.add(new_station);
  yield put(refreshData());
}

export function* deleteDocument(action) {
  const { firebase } = yield select(state => state)
  firebase.stationsCollection.doc(action.payload.data).delete();
  yield put(refreshData());
}
